import { render, staticRenderFns } from "./CreateZm.vue?vue&type=template&id=6a42624e&scoped=true"
import script from "./CreateZm.vue?vue&type=script&lang=js"
export * from "./CreateZm.vue?vue&type=script&lang=js"
import style0 from "./CreateZm.vue?vue&type=style&index=0&id=6a42624e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42624e",
  null
  
)

export default component.exports